module.exports = __webpack_public_path__ + "assets/search.ca71da11.svg";